import { render } from "./carruselComponent.vue?vue&type=template&id=124de781&scoped=true"
import script from "./carruselComponent.vue?vue&type=script&lang=js"
export * from "./carruselComponent.vue?vue&type=script&lang=js"

import "./carruselComponent.vue?vue&type=style&index=0&id=124de781&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124de781"]])

export default __exports__